import { AuthenticationApi, Configuration, VerifyLinkDto, VerifyLinkRequest } from "@api/client";
import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { companySetIdCliente } from "common/_redux/company/actions";
import { praticaSetId } from "common/_redux/pratica/actions";
import { ThunkApiConfig } from "core/store";
import getConfiguration, { errorHandler } from "core/store/config";

const enum InvitationReducer {
	reset = "[INVITATION] Reset",
	setShowHeader = "[INVITATION] Set Show Header",
	setActiveAccordion = "[INVITATION] Set Active Accordion",
	getInvitation = "[INVITATION] Get Invitation",
	getProvince = "[INVITATION] Get Province",
	getComuni = "[INVITATION] Get Comuni",
}

export const invitationReset = createAction(InvitationReducer.reset);

export const invitationSetShowHeader = createAction<boolean>(InvitationReducer.setShowHeader);

export const invitationSetActiveAccordion = createAction<number>(
	InvitationReducer.setActiveAccordion
);

export const invitationGetInvitation = createAsyncThunk<
	VerifyLinkDto | undefined,
	VerifyLinkRequest,
	ThunkApiConfig
>(InvitationReducer.getInvitation, async (request, { dispatch, extra, getState }) => {
	try {
		return await new AuthenticationApi(getConfiguration(Configuration, extra, getState))
			.verifyLink(request)
			.then((res) => {
				if (res.idPratica) dispatch(praticaSetId(res.idPratica));
				if (res.idCliente) dispatch(companySetIdCliente(res.idCliente));

				return res;
			});
	} catch (error) {
		if ((error as any)?.response?.status === 400) {
			return (error as any)?.response;
		} else errorHandler(error, dispatch);
	}
});
